import clsx from "clsx";
import {
  RENTAL_PERIOD_LABELS,
  RENTAL_PERIODS,
  type RentalPeriod,
} from "@/lib/rentalPeriod";

export function RentalPeriodPicker({
  value,
  onChange,
  disabled = false,
}: {
  value: RentalPeriod;
  onChange: (value: RentalPeriod) => void;
  disabled?: boolean;
}) {
  return (
    <div
      className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-6"
      role="radiogroup"
      aria-label="Abrechnungszeitraum"
    >
      {RENTAL_PERIODS.map((period) => {
        const selected = value === period;
        return (
          <button
            key={period}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => onChange(period)}
            className={clsx(
              "rounded-xl border px-2 py-2.5 text-sm font-medium transition",
              selected
                ? "border-accent bg-accent/15 text-label shadow-sm"
                : "border-separator bg-card text-label-secondary hover:bg-fill-tertiary",
              disabled && "cursor-not-allowed opacity-60",
            )}
          >
            {RENTAL_PERIOD_LABELS[period]}
          </button>
        );
      })}
    </div>
  );
}
